function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Children, useMemo, useRef, useState } from "react";
import { unlockPageScroll, lockPageScroll } from "../../../utils/scrollLock";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useCarousel } from "./CarouselContext";
import { SlideProvider } from "../SlideContext/SlideContext";
import Slide from "./Slide";
import useStyle from "./Slider.style";
import { VisuallyHiddenElement } from "../../VisuallyHiddenElement";
export var SWIPE_MAX_DURATION = 300;
export var SWIPE_MIN_DISTANCE = 25;
export var Slider = function(param) {
    var children = param.children;
    var sliderRef = useRef(null);
    var animationRef = useRef();
    var ref7 = _slicedToArray(useState({}), 2), ref1 = ref7[0], touchStartX = ref1.touchStartX, touchStartY = ref1.touchStartY, startTime = ref1.startTime, setTouchStart = ref7[1];
    var ref2 = _slicedToArray(useState({
        deltaX: 0,
        deltaY: 0
    }), 2), deltaX = ref2[0].deltaX, setTouchDelta = ref2[1];
    var ref3 = _slicedToArray(useState(false), 2), isTouching = ref3[0], setIsTouching = ref3[1];
    var ref4 = _slicedToArray(useState(), 2), elementWithLockedScroll = ref4[0], setElementWithLockedScroll = ref4[1];
    var ref5 = useCarousel(), _state = ref5.state, testID = _state.testID, slideIndex = _state.slideIndex, slideCount = _state.slideCount, cols = _state.cols, nextSlidesCount = _state.nextSlidesCount, previousSlidesCount = _state.previousSlidesCount, showOverhang = _state.showOverhang, isRtl = _state.isRtl, slideHeight = _state.slideHeight, scrollLock = _state.scrollLock, announceNav = _state.announceNav, hideDots = _state.hideDots, setSlideIndex = ref5.actions.setSlideIndex;
    var ref6 = useStyle({
        cols: cols,
        deltaX: deltaX,
        hasNext: !!nextSlidesCount,
        hasPrevious: !!previousSlidesCount,
        isRtl: isRtl,
        isTouching: isTouching,
        showOverhang: showOverhang,
        slideHeight: slideHeight,
        slideIndex: slideIndex
    }), wrapper = ref6.wrapper, slider = ref6.slider;
    var slides = useMemo(function() {
        return Children.toArray(children).map(function(slide, idx) {
            return _jsx(SlideProvider, {
                index: idx,
                sliderRef: sliderRef,
                children: _jsx(Slide, {
                    index: idx,
                    children: slide
                }, idx)
            }, idx);
        });
    }, [
        children
    ]);
    if (!cols) {
        return null;
    }
    var onTouchStart = function(e) {
        if (scrollLock) {
            lockPageScroll(scrollLock, setElementWithLockedScroll);
        }
        var ref = e.targetTouches[0], screenX = ref.screenX, screenY = ref.screenY;
        setTouchStart({
            touchStartX: screenX,
            touchStartY: screenY,
            startTime: +new Date()
        });
        setTouchDelta({
            deltaX: 0,
            deltaY: 0
        });
        setIsTouching(true);
    };
    var onTouchMove = function(e) {
        var ref = e.targetTouches[0], screenX = ref.screenX, screenY = ref.screenY;
        animationRef.current = window === null || window === void 0 ? void 0 : window.requestAnimationFrame(function() {
            setTouchDelta({
                deltaX: screenX - (touchStartX || 0),
                deltaY: screenY - (touchStartY || 0)
            });
        });
    };
    var onTouchEnd = function() {
        if (!elementWithLockedScroll) {
            return;
        }
        unlockPageScroll(elementWithLockedScroll, setElementWithLockedScroll);
        if (animationRef.current) {
            window === null || window === void 0 ? void 0 : window.cancelAnimationFrame(animationRef.current);
        }
        var duration = +new Date() - (startTime || 0);
        var swipeDirection = -deltaX / Math.max(Math.abs(deltaX), 1);
        var fractionalDelta = sliderRef.current ? deltaX / sliderRef.current.clientWidth : 0;
        var slideDelta = -Math.round(fractionalDelta * cols);
        if (Math.abs(slideDelta) < 1 && duration < SWIPE_MAX_DURATION && Math.abs(deltaX) > SWIPE_MIN_DISTANCE) {
            slideDelta = swipeDirection;
        }
        slideDelta *= isRtl ? -1 : 1;
        setTouchDelta({
            deltaX: 0,
            deltaY: 0
        });
        setIsTouching(false);
        setSlideIndex(Math.max(Math.min(slideIndex + slideDelta, slideCount - cols), 0));
    };
    var onTouchCancel = onTouchEnd;
    var SliderElement = hideDots ? 'ul' : 'div';
    return _jsxs("div", _objectSpread({
        ref: sliderRef,
        css: wrapper
    }, injectTestId(testID && "".concat(testID, ".slider")), {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onTouchCancel: onTouchCancel,
        children: [
            announceNav && _jsx(VisuallyHiddenElement, {
                "aria-live": "polite",
                children: announceNav({
                    start: slideIndex + 1,
                    end: slideIndex + cols,
                    total: slideCount
                })
            }),
            _jsx(SliderElement, _objectSpread({
                css: slider
            }, injectTestId(testID && "".concat(testID, ".slider-element")), {
                children: slides
            }))
        ]
    }));
};
export default Slider;
